import { render, staticRenderFns } from "./RejectionModel.vue?vue&type=template&id=14bce721&"
import script from "./RejectionModel.vue?vue&type=script&lang=js&"
export * from "./RejectionModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports